/* Budget Creation - static option lists + form template (Supplier App) */

export const departmentOptions = [
  { id: 1, name: "IT Department", code: "D01", description: "IT Department" },
  { id: 2, name: "Human Resources", code: "D02", description: "Human Resources" },
  { id: 3, name: "Finance", code: "D03", description: "Finance" },
  { id: 4, name: "Operations", code: "D04", description: "Operations" },
  { id: 5, name: "Marketing", code: "D05", description: "Marketing" },
  { id: 6, name: "Production", code: "D06", description: "Production" },
  { id: 7, name: "Quality Control", code: "D07", description: "Quality Control" },
  { id: 8, name: "Research & Development", code: "D08", description: "Research & Development" },
  { id: 9, name: "Administration", code: "D09", description: "Administration" },
  { id: 10, name: "Procurement", code: "D10", description: "Procurement" },
];

export const financialYearOptions = [
  { id: 1, name: "2026-2027", code: "FY2627", description: "2026-2027" },
  { id: 2, name: "2025-2026", code: "FY2526", description: "2025-2026" },
  { id: 3, name: "2024-2025", code: "FY2425", description: "2024-2025" },
  { id: 4, name: "2027-2028", code: "FY2728", description: "2027-2028" },
];

export const budgetPeriodOptions = [
  { id: 1, name: "Annual", code: "ANNUAL", description: "Annual" },
  { id: 2, name: "Quarterly", code: "QUARTERLY", description: "Quarterly" },
  { id: 3, name: "Monthly", code: "MONTHLY", description: "Monthly" },
  { id: 4, name: "Half Yearly", code: "HALF_YEARLY", description: "Half Yearly" },
];

export const currencyOptions = [
  { id: 1, name: "INR", code: "INR", description: "Indian Rupee" },
  { id: 2, name: "USD", code: "USD", description: "US Dollar" },
  { id: 3, name: "EUR", code: "EUR", description: "Euro" },
  { id: 4, name: "GBP", code: "GBP", description: "British Pound" },
];

export const statusOptions = [
  { id: 1, name: "Draft", code: "DRAFT", description: "Draft" },
  { id: 2, name: "Active", code: "ACTIVE", description: "Active" },
  { id: 3, name: "Approved", code: "APPROVED", description: "Approved" },
  { id: 4, name: "Rejected", code: "REJECTED", description: "Rejected" },
];

/* Same options as PR page Purchase Category (master data codeType: PurchaseCategory) - fallback */
export const categoryFallbackOptions = [
  { id: 1, name: "100 - Raw Material", code: "100", description: "Raw Material" },
  { id: 2, name: "200 - MRO Spare Parts", code: "200", description: "MRO Spare Parts" },
  { id: 3, name: "300 - Packaging Material", code: "300", description: "Packaging Material" },
];

/* Field labels - used on details page */
export const budgetFieldLabels = {
  documentNumber: "Budget No",
  budgetName: "Budget Name",
  company: "Company",
  businessUnit: "Business Unit",
  category: "Category",
  department: "Department",
  costCenter: "Cost Center",
  financialYear: "Financial Year",
  budgetPeriod: "Budget Period",
  budgetAmount: "Budget Amount",
  currency: "Currency",
  startDate: "Start Date",
  endDate: "End Date",
  description: "Description",
  status: "Status",
};

export const getBudgetFormTemplate = () => ({
  budgetName: "",
  company: "",
  businessUnit: "",
  category: "",
  department: "",
  costCenter: "",
  financialYear: "",
  budgetPeriod: "",
  budgetAmount: "",
  currency: "INR",
  startDate: "",
  endDate: "",
  description: "",
  status: "Draft",
});
